import { put, select } from "redux-saga/effects";
import { getHubspotAuthURLFailure, getHubspotAuthURLSuccess } from "../actionCreators";
import { IntegrationService } from "../integration.service";

export function* handleGetHubspotAuthURL() {
    try {
        const formId: string = yield select(state => state.forms.current._id);

        const { data } = yield IntegrationService.getHubspotAuthURL(formId);

        yield put(
            getHubspotAuthURLSuccess({
                success: true,
                message: "",
                data: data.data,
            }),
        );
    } catch (error: any) {
        const errorMessage = error.response?.data?.message || "Failed to get Hubspot authentication URL";
        yield put(getHubspotAuthURLFailure(errorMessage));
    }
}
